import React, { PureComponent } from 'react';

import ReactTable from 'react-table';

import { TableWrapper } from 'modules/list/table';
import { Button, Text } from '@cuemath/comps';
import { epochToDate } from 'utils';
import { LinkNav } from 'modules/form';

export default class PaymentsList extends PureComponent {
  onFilteredChange = filters => {
    this.props.onFilter(filters);
  };

  render() {
    const { paymentLinkData, count } = this.props;

    const tableColumns = [
      {
        Header: `Payment Links (${count})`,
        columns: [
          {
            Header: 'Created On',
            accessor: 'created_on_ts',
            width: 100,
            Cell: ({ value }) => (value ? epochToDate(value, 'DD-MM-YYYY') : ''),
          },
          {
            Header: 'Created BY',
            accessor: 'created_by_name',
            width: 200,
          },
          {
            Header: 'Name',
            accessor: 'name',
            width: 150,
          },
          {
            Header: 'Grade',
            accessor: 'grade',
            width: 50,
          },
          {
            Header: 'Product',
            accessor: 'product_type',
            width: 100,
          },
          {
            Header: 'Link',
            accessor: 'link',
            width: 80,
            Cell: row => {
              return row.original.link ? (
                <LinkNav
                  target="_blank"
                  to={{
                    pathname: `${row.original.link}`,
                  }}
                >
                  Link
                </LinkNav>
              ) : (
                <Text></Text>
              );
            },
          },
          {
            Header: 'Amount',
            accessor: 'amount',
            width: 100,
          },
          {
            Header: 'Tenure',
            accessor: 'duration',
            width: 100,
          },
          {
            Header: 'Currency',
            accessor: 'currency',
            width: 100,
          },
          {
            Header: 'Payment Type',
            accessor: 'payment_type',
            width: 200,
          },
          {
            Header: 'Paid On',
            accessor: 'paid_on',
            Cell: ({ value }) => (value ? epochToDate(value, 'DD-MM-YYYY') : ''),
            width: 100,
          },
          {
            Header: 'Invoice ID',
            accessor: 'invoice_id',
            width: 300,
          },
          {
            Header: 'Credits Applied',
            accessor: 'credits_applied',
            width: 300,
          },
          {
            Header: 'Status',
            accessor: 'state',
            width: 100,
          },
        ],
      },
    ];

    return (
      <React.Fragment>
        <TableWrapper>
          <ReactTable
            data={paymentLinkData}
            className="-striped -highlight"
            manual
            showPaginationTop
            showPageSizeOptions={false}
            filterable={false}
            sortable={false}
            resizable={false}
            onFilteredChange={this.onFilteredChange}
            defaultFilterMethod={(filter, row) => String(row[filter.id]) === filter.value}
            defaultPageSize={20}
            columns={tableColumns}
            style={{ textAlign: 'center' }}
          />
        </TableWrapper>
      </React.Fragment>
    );
  }
}
